import { POST } from "../../index";

export const selectShiftList = (param) => POST("/v1/shift/selectShiftList", param);
export const insertShift = (param) => POST("/v1/shift/insertShift", param);
export const updateShift = (param) => POST("/v1/shift/updateShift", param);
export const deleteShift = (param) => POST("/v1/shift/deleteShift", param);
export const selectShift = (param) => POST("/v1/shift/selectShift", param);

export const selectShiftApplication = (param) => POST("/v1/shift/selectShiftApplication", param);
export const insertShiftApplication = (param) => POST("/v1/shift/insertShiftApplication", param);
export const updateShiftApplication = (param) => POST("/v1/shift/updateShiftApplication", param);
export const deleteShiftApplication = (param) => POST("/v1/shift/deleteShiftApplication", param);
export const selectApplication = (param) => POST("/v1/shift/selectApplication", param);
export const choiceShiftList = (param) => POST("/v1/shift/choiceShiftList", param);
export const choiceShiftCar = (param) => POST("/v1/shift/choiceShiftCar", param);
export const choiceShiftDriver = (param) => POST("/v1/shift/choiceShiftDriver", param);

